import { render, staticRenderFns } from "./bussinessTypeMinor.vue?vue&type=template&id=066c60ea&scoped=true"
import script from "./bussinessTypeMinor.vue?vue&type=script&lang=js"
export * from "./bussinessTypeMinor.vue?vue&type=script&lang=js"
import style0 from "./bussinessTypeMinor.vue?vue&type=style&index=0&id=066c60ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c60ea",
  null
  
)

export default component.exports